import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router);
const login = ()=>import('@/components/login.vue')
const maintLogin = ()=>import('@/components/maintLogin.vue')
const savePassword = ()=>import('@/components/savePassword.vue')
const test = ()=>import('@/components/managePage/gridService/task/taskManage.vue');
const unitCheckRuleConfig = ()=>import('@/components/managePage/unitCheckRuleConfig.vue')
function loadView() {
  if(window.location.host.indexOf('maintain') > -1){
    return () => import(`@/components/maintLogin.vue`)
  }else if(window.location.host.indexOf('hostcontrol') > -1){
    if(window.location.host.indexOf('zh-security') > -1) {
      return () => import(`@/components/controlZhSecurityLogin.vue`)
    }else{
      return () => import(`@/components/controlLogin.vue`)
    }
  }else if(window.location.host.indexOf('elevator') > -1 || window.location.host.indexOf('iotperception') > -1 || window.location.host.indexOf('agencymonitor') > -1){
    if(window.location.host.indexOf('zh-security') > -1) {
      return () => import(`@/components/elevatorZhSecurityLogin.vue`)
    }else{
      return () => import(`@/components/elevatorLogin.vue`)
    }
  }else if(window.location.host.indexOf('residence') > -1){
    return () => import(`@/components/residenceLogin.vue`)
  }else if(window.location.host.indexOf('zhdhq') > -1){
    return () => import(`@/components/zhdhqLogin.vue`)
  }else {
    if(window.location.host.indexOf('zh-security') > -1) {
      return () => import(`@/components/loginZhSecurityLogin.vue`)
    }else{
      return () => import(`@/components/login.vue`)
    }

    // return () => import(`@/components/login.vue`)
    // return () => import(`@/components/zhdhqLogin.vue`)
    // return () => import(`@/components/controlLogin.vue`)
    // return () => import(`@/components/elevatorLogin.vue`)
    // return () => import(`@/components/residenceLogin.vue`)
    // return () => import(`@/components/maintLogin.vue`)

    // return () => import(`@/components/controlZhSecurityLogin.vue`)
    // return () => import(`@/components/elevatorZhSecurityLogin.vue`)
    // return () => import(`@/components/loginZhSecurityLogin.vue`)
  }
}
//固定的路由定义
let constMap = [
  // 登录
  {
    path: '/login',
    name: 'login',
    component: loadView()
  },
  // 404
  {
    path: '/404',
    name: '404',
    component: ()=>import('@/components/404.vue')

  },
  // 注销账号
  {
    path: '/signOut',
    name: 'signOut',
    component: ()=>import('@/components/signOut.vue')

  },
  // 注销账号
  {
    path: '/signOutTwo',
    name: 'signOutTwo',
    component: ()=>import('@/components/signOutTwo.vue')

  },
  // 注销账号
  {
    path: '/signOutThree',
    name: 'signOutThree',
    component: ()=>import('@/components/signOutThree.vue')

  },
  // 修改密码
  {
    path: '/savePassword',
    name: 'savePassword',
    component: savePassword

  },

  {
    path: '/ZHlogin',
    name: 'ZHlogin',
    component: resolve => {
      require(['@/components/ZHlogin.vue'], resolve);
    }
  },
  {
    path: '/getMap',
    name: 'getMap',
    component: resolve => {
      require(['@/components/getMap.vue'], resolve);
    }
  },
  {
    path: '/main',
    name: 'myManageMain',
    redirect: '/main/index',
    component: resolve => {
      require(['@/components/manage/Layout.vue'], resolve);
    },
    children: [
      {
        path: 'index',
        name: 'home_index',
        component: resolve => {
          require(['@/components/managePage/home.vue'], resolve);
        },
      },
      // 20241010消防设施管理
      // {
      //   path:'fireFacilities',
      //   name:'fireFacilities',
      //   component:()=>import('@/components/managePage/fireFacilities.vue')
      // }
    ]
  },
  //单位查看
  {
    path: '/unitViewer/:unitId',
    name: 'unitViewer',
    component: resolve => {
      require(['@/components/unitViewer.vue'], resolve);
    },
    props: true //使用props传参
  },
  //单位查看-视频界面

  {
    path: '/unitVideoViewer/:unitId',
    name: 'unitVideoViewer',
    component: resolve => {
      require(['@/components/unitVideoViewer.vue'], resolve);
    },
    props: true //使用props传参
  },
  //网格化统计镇级点击
  {
    path: '/townGridManage',
    name: 'townGridManage',
    component: resolve => {
      require(['@/components/townGridManage.vue'], resolve);
    },
  },
  //支队级别地图监控
  {
    path: '/mapMonitor',
    name: 'mapMonitor',
    component: resolve => {
      require(['@/components/map/mapMonitor.vue'], resolve);
    },
    props: true //使用props传参
  },
  // 城镇网格化管理
  {
    path: '/townGridManage',
    name: 'townGridManage',
    component: resolve => {
      require(['@/components/townGridManage.vue'], resolve);
    },
  },
  //自动登录
  {
    path: '/gotoSuperIndex',
    name: 'gotoSuperIndex',
    component: resolve => {
      require(['@/components/super/doAutoLoginPage.vue'], resolve);
    },
    props: true
  },
  //自动登录--惠州
  {
    path: '/gotoHuiZhouDataVisual',
    name: 'gotoHuiZhouDataVisual',
    component: resolve => {
      require(['@/components/super/huizhouAutoLoginPage'], resolve);
    },
    props: true
  },
  //自动登录,单位
  {
    path: '/gotoUnitViewer',
    name: 'gotoUnitViewer',
    component: resolve => {
      require(['@/components/unitAutoLogin.vue'], resolve);
    },
    props: true
  },
  //自动登录,单位视频界面
  {
    path: '/gotoVideoViewer',
    name: 'gotoVideoViewer',
    component: resolve => {
      require(['@/components/unitVideoAutoLogin.vue'], resolve);
    },
    props: true
  },
  //自动登录,势态,电梯...
  {
    path: '/autoLogin',
    name: 'autoLogin',
    component: resolve => {
      require(['@/components/autoLogin.vue'], resolve);
    },
    props: true
  },

  // 2022/09/19数据可视化
  {
    path: '/dataVisual',
    name: 'dataVisual',
    component: resolve => {
      require(['@/components/unit/index/dataVisual.vue'], resolve);
    },
    props: true
  },
  {
    path: '/elevatorMonitor',
    name: 'elevatorMonitor',
    component: resolve => {
      require(['@/components/elevatorMonitor/index.vue'], resolve);
    },
    props: true
  },
  {
    path: '/IoTPerception',
    name: 'IoTPerception',
    component: resolve => {
      require(['@/components/bankMonitor/index.vue'], resolve);
    },
    props: true
  },
  {
    path: '/agencyMonitor',
    name: 'agencyMonitor',
    component: resolve => {
      require(['@/components/cardMonitor/index.vue'], resolve);
    },
    props: true
  },
  {
    path: '/agencyMonitor/:unitId',
    name: 'agencyMonitor',
    component: resolve => {
      require(['@/components/cardMonitor/index.vue'], resolve);
    },
    props: true
  },
  {
    path: '/superVideoViewer',
    name: 'superVideoViewer',
    component: resolve => {
      require(['@/components/superVideoViewer.vue'], resolve);
    },
    props: true
  },
  // 维保单位首页
  {
    path: '/maint/index',
    name: 'maintIndex',
    component: resolve => {
      require(['@/components/maintIndex/index.vue'], resolve);
    },
    props: true
  },
  // 主机控制界面
  {
    path: '/hostControl/:unitId',
    name: 'hostControl',
    component: resolve => {
      require(['@/components/hostControl/index.vue'], resolve);
    },
    props: true
  },
  // 主机控制自动登录
  {
    path: '/hostControlAutoLogin',
    name: 'hostControlAutoLogin',
    component: resolve => {
      require(['@/components/hostControlAutoLogin.vue'], resolve);
    },
    props: true
  },
  // 人脸识别免登录
  {
    path: '/faceRecognition',
    name: 'faceRecognition',
    component: resolve => {
      require(['@/components/super/faceRecognition.vue'], resolve);
    },
    props: true
  },
    //单位查看
    {
      path: '/unitMaintViewer/:unitId',
      name: 'unitMaintViewer',
      component: resolve => {
        require(['@/components/unitMaintViewer.vue'], resolve);
      },
      props: true //使用props传参
    },

]
//加载固定路由
export default new Router({
  routes: constMap
})










// WEBPACK FOOTER //
// ./src/router/index.js